import { interactionType , actionType } from "../actionType/actionType";

export const openCloseMenu = (value) =>{
    return{
        type: interactionType.OPEN_CLOSE_MENU,
        payload: value
    }
}

export const closePaymenu = (value) =>{
  return{
    type: interactionType.PAY_MENU,
    payload: value
  }
}

export const closePayMenuNew = (value) =>{
  return{
    type: interactionType.PAY_MENU_NEW,
    payload: value
  }
}

export const closeCheckIn = (value) => {
    return {
      type: actionType.CLOSE_CHECKIN,
      payload: value,
    };
  };
  
  export const closeCheckOut = (value) => {
    return {
      type: actionType.CLOSE_CHECKOUT,
      payload: value,
    };
  };
  
  export const handleLogout = () =>{
    return {
      type: actionType.LOGOUT,
      payload:false
    }
  }

  export const resetChangeFaceVal = (value) =>{
    return{
      type: interactionType.PHOTO_CHANGE,
      payload:value
    }
  }

  export const paymenIsSuccessfull = () =>{
    return{
      type: interactionType.SUCCESSFULL_PAYMENT
    }
  }

  export const notificationAction = (value) =>{
    return{
      type: interactionType.NOTIFICATION_DRAWER,
      payload: value
    }
  }
  
  export const openCloseApplyLeave = (value) =>{
    return{
      type: interactionType.OPEN_CLOSE_LEAVE_FORM,
      payload: value
    }
  }
